module.exports = __webpack_public_path__ + "static/media/horseracing.ac5f282b.png";